<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="epigraph" role="doc-epigraph">
<p class="SP" id="ep"> </p>
<p class="SP"> </p>
<p class="FM-Epigraph-verse-fmepiv"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">Beyond these walls</span></p>
<p class="FM-Epigraph-verse-fmepiv-bot">Sweet freedom calls.</p>
<p class="FM-Epigraph-Source-fmeps">—Eugene V. Debs, 1918</p>
<p class="FM-Epigraph-verse-fmepiv-bot">It was a long time ago now. And it was yesterday.</p>
<p class="FM-Epigraph-Source-fmeps">—Kate Atkinson, 2013</p>
<p class="FM-Epigraph-verse-fmepiv-bot">What we now call the present, this fleeting <i>nownownow</i>, is constantly overshadowed by a past now.</p>
<p class="FM-Epigraph-Source-fmeps">—G<span class="fm-epigraph-source-fmeps-_span-accent-characters-acc">ü</span>nter Grass, 2007</p>
<p class="FM-Epigraph-verse-fmepiv-bot">The suppressed past will rankle and return.</p>
<p class="FM-Epigraph-Source-fmeps">—Eva Hoffman, 2004</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?532e92e4